import React from 'react'
import BigNumber from 'bignumber.js'
import moment from 'moment'
import { Text, View } from 'styles/reactnative'
import { CButton } from 'app/components/Common'
import { COLORS } from 'app/constants'
import { Space, Tag } from 'antd'
import { typeFromLevel } from 'utils/ExpensiveFunction'
import { TableColumns } from 'app/components'
import LevelIcon from '../../../components/LevelIcon'
import EntryTime from '../../../components/PositionColumns/EntryTime'
import UserTag from '../../../components/UserTag'
import MemoInput from './MemoInput'
import ActionButton from './ActionButton'
import { TagWrap } from '../../../components/AdminUserModal/UserInfoTabs/styles'

export const AdminWithdrawalTableColumn: any = (mutate, openModal) => {
	return [
		{
			title: '번호',
			dataIndex: 'id',
			align: 'center',
			width: 100,
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '생성일',
			dataIndex: 'created_at',
			align: 'center',
			width: 130,
			render: (text, data) => <EntryTime time={text} />,
		},
		{
			title: '승인일',
			dataIndex: 'confirm_at',
			align: 'center',
			width: 130,
			render: (text, data) => {
				{
					return text ? <EntryTime time={text} /> : <Text>-</Text>
				}
			},
		},
		{
			title: '회원',
			dataIndex: 'user_id',
			align: 'center',
			width: 150,
			render: (text, data) => (
				<UserTag
					userid={data?.user_id}
					email={data?.email}
					phone={data?.phone}
					nickname={data?.fullname || data?.nickname}
					onClick={() => {
						openModal(data?.user_id)
					}}
				/>
			),
		},
		{
			title: '진행',
			dataIndex: 'process',
			align: 'center',
			width: 50,
			render: (text, data) => (
				<TagWrap>
					{text == 1 ? (
						<Tag
							style={{
								backgroundColor: '#f79336',
								color: 'white',
							}}>
							대기
						</Tag>
					) : text == 2 ? (
						<Tag
							style={{
								backgroundColor: COLORS.lightGreen,
								color: 'white',
							}}>
							완료
						</Tag>
					) : text == 3 ? (
						<Tag
							style={{ backgroundColor: '#444', color: 'white' }}>
							검토중
						</Tag>
					) : text == 4 ? (
						<Tag style={{ color: 'red' }}>거절됨</Tag>
					) : (
						<Tag>취소</Tag>
					)}
				</TagWrap>
			),
		},
		{
			title: '코인',
			align: 'center',
			width: 80,
			dataIndex: 'symbol',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '네트워크',
			align: 'center',
			width: 80,
			dataIndex: 'network',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '출금주소',
			align: 'center',
			dataIndex: 'address',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: 'TXID',
			align: 'center',
			dataIndex: 'txid',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '출금수량',
			align: 'center',
			dataIndex: 'amount',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '관리메모',
			align: 'center',
			dataIndex: 'memo',
			render: (text, data) => (
				<MemoInput data={data} type={'W'} mutate={mutate} />
			),
		},
		{
			title: '관리',
			align: 'center',
			width: 150,
			dataIndex: 'action',
			render: (text, data) => (
				<Space.Compact direction="horizontal">
					{data?.process != 2 && (
						<>
							{data?.process != 3 && (
								<ActionButton
									title={'검토'}
									process={3}
									mutate={mutate}
									id={data?.id}
								/>
							)}
							{data?.process != 2 && (
								<ActionButton
									title={'승인'}
									process={2}
									mutate={mutate}
									id={data?.id}
								/>
							)}
							{data?.process != 4 && (
								<ActionButton
									title={'거절'}
									process={4}
									mutate={mutate}
									id={data?.id}
								/>
							)}
						</>
					)}
				</Space.Compact>
			),
		},
	]
}
